import { createFieldSelectorHook } from 'src/lib/sweetState';

import { WorkspaceStore } from './WorkspaceStore';

export const useCurrentWorkspaceId = createFieldSelectorHook(WorkspaceStore, 'currentWorkspaceId');
